import { Field, Form } from "react-final-form";
import { Text, Title } from "../../components/typography";
import { useDispatch, useSelector } from "react-redux"; // 👈 New Redux hooks

import { Button } from "../../components/button";
import { Input } from "../../components/inputs";
import { UserLogIn } from "../../redux/user"; // 👈 Make sure this import is correct
import styled from "styled-components";
import { useCallback } from "react";

export const LoginForm = ({ setPassReq }) => {
  const dispatch = useDispatch(); // 👈 New dispatch hook
  const { error } = useSelector((state) => state.users); // 👈 New selector hook

  const onSubmitValues = useCallback(
    (values) => {
      // 👈 Use useCallback for memoization
      dispatch(UserLogIn(values)); // 👈 Dispatch the action
    },
    [dispatch]
  );

  return (
    <Form
      onSubmit={onSubmitValues}
      validate={(values) => {
        const errors = {};

        if (!values.email) {
          errors.email = "You must enter your email.";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
          errors.email = "Invalid email address";
        }

        if (!values.password) {
          errors.password = "You must enter your password.";
        }

        return errors;
      }}
    >
      {({ handleSubmit, pristine, submitting, invalid }) => (
        <form onSubmit={handleSubmit}>
          <Title number={11}>Sign In</Title>
          <Text scale="small">
            Authorized personnel only. All others will be prosecuted to the
            extent of the law.
          </Text>
          {error && ( // 👈 Access the error from the useSelector hook
            <Text scale="small" color="red">
              {error}
            </Text>
          )}
          <Field
            label="Email"
            name="email"
            type="email"
            component={Input}
            required
            autoComplete="on"
          />
          <Field
            label="Password"
            name="password"
            type="password"
            component={Input}
            autoComplete="current-password"
            required
          />
          <InfoFlex>
            <Button
              type="submit"
              varient="outlineBK"
              disabled={submitting || invalid}
              text={submitting ? "Submitting....." : "Login"}
            />
            {/* <Text
              scale="small"
              color="gray"
              onClick={() => setPassReq()} // 👈 Access setPassReq directly
              style={{ cursor: "pointer" }}
            >
              Can't login
            </Text> */}
          </InfoFlex>
        </form>
      )}
    </Form>
  );
};

const InfoFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-top: 2rem;

  p,
  button,
  a {
    margin: 0;
    width: fit-content;
  }
`;
